import React from 'react';
import AnnouncementsList from './AnnouncementsList';
import classes from './AnnouncementsPage.module.css';


const AnnouncementTableContainer = ({
    announcementCreate,
    setAnnouncementCreate,
    setSelectedAnnouncement,
    ...props
}) => {

    return (
        <div className={classes.TableContainer}>
            <div  className={classes.GridContainer}>
                <AnnouncementsList
                    announcementCreate={announcementCreate}
                    setAnnouncementCreate={setAnnouncementCreate} 
                    setSelectedAnnouncement={setSelectedAnnouncement}
                />
            </div>
        </div>
    );
};

export default AnnouncementTableContainer;
